import { useEffect } from 'react';
import { useStoreState, useStoreActions } from '../store';

export function useColumnWidth() {
  const isClient = typeof window === 'object';
  const columnWidth = useStoreState((state) => state.navigation.columnWidth);
  const setWindowSize = useStoreActions((actions) => actions.navigation.updateWindowSize);

  useEffect(() => {
    if (!isClient) {
      return undefined;
    }

    function handleResize() {
      const size = isClient ? window.innerWidth : 1200;
      setWindowSize(size);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isClient, setWindowSize]);

  return columnWidth;
}
